import { render, staticRenderFns } from "./otherArtisanConfirmationModal.vue?vue&type=template&id=1d6455de"
import script from "./otherArtisanConfirmationModal.vue?vue&type=script&lang=ts"
export * from "./otherArtisanConfirmationModal.vue?vue&type=script&lang=ts"
import style0 from "./otherArtisanConfirmationModal.vue?vue&type=style&index=0&id=1d6455de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports